import React from 'react';
import { Modal } from '@components/main-components/modals/Modal';
import { useModal } from '@context/modal';

export const DescriptionModal = ({ name, description }: { name: string; description: string }) => {
  const { closeCancelModal } = useModal();

  const header = <div className="flex items-center">{name}</div>;
  return (
    <Modal
      header={header}
      body={<p className="font-base text-base-m">{description}</p>}
      closeModal={closeCancelModal}
    />
  );
};
